/**
 * Site-wide Lenis smooth scroll + GSAP ScrollTrigger sync.
 * Load order: gsap.min.js → ScrollTrigger.min.js → scroll-trigger-viewport.js → lenis.min.js → this file
 */
(function () {
  if (typeof window.Lenis === "undefined") return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var lenis = new window.Lenis({
    lerp: 0.1,
    smoothWheel: true,
    syncTouch: false,
    wheelMultiplier: 1,
    touchMultiplier: 1,
  });

  window.lenis = lenis;

  lenis.on("scroll", function (e) {
    if (typeof window.ScrollTrigger !== "undefined") {
      window.ScrollTrigger.update();
    }
    if (typeof window.onoureOnLenisScroll === "function") {
      window.onoureOnLenisScroll(e);
    }
  });

  if (typeof window.ScrollTrigger !== "undefined") {
    // Keep mobile normalizeScroll from scroll-trigger-viewport.js (do not disable here).
    if (typeof window.onoureApplyNormalizeScroll === "function") {
      window.onoureApplyNormalizeScroll();
    }
  }

  if (typeof window.gsap !== "undefined") {
    window.gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });
    window.gsap.ticker.lagSmoothing(0);
  } else {
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener("click", function (e) {
      if (anchor.closest(".nav-tabs")) return;
      var href = anchor.getAttribute("href");
      if (!href || href === "#") return;
      var target = document.querySelector(href);
      if (!target) return;
      if (target.classList.contains("tab-pane")) return;
      e.preventDefault();
      lenis.scrollTo(target);
    });
  });

  window.addEventListener("load", function () {
    if (typeof window.ScrollTrigger !== "undefined") {
      window.ScrollTrigger.refresh();
    }
    if (typeof window.onoureSyncHeaderAfterLayout === "function") {
      window.onoureSyncHeaderAfterLayout();
    }
  });
})();